import { useTargetedModel } from '@cotera/client/v0/actions/framework';
import type { WorkflowNodeViewData } from './components/node/types';
import {
  resolveGraphNodeRenderableNodeByViewData,
  useWorkflowRenderCatalog,
  type WorkflowGraphNodeViewModelHandle,
} from './workflow-render-catalog';
import { WorkflowModel } from './workflow.model';

/**
 * Resolves the per-entity view model for a workflow graph node on the canvas,
 * using the render catalog's descriptor key + {@link resolveModelEntityId}.
 *
 * Returns `null` when the node type has no view model (e.g. tool call).
 */
export function useWorkflowGraphNodeViewModel(
  node: WorkflowNodeViewData
): WorkflowGraphNodeViewModelHandle | null {
  const catalog = useWorkflowRenderCatalog();
  const workflowModel = useTargetedModel(WorkflowModel);

  if (workflowModel === null) {
    return null;
  }
  const entry = resolveGraphNodeRenderableNodeByViewData(catalog, node);
  if (entry.models === undefined) {
    return null;
  }
  const resolveEntityId = entry.resolveModelEntityId;
  if (resolveEntityId === undefined) {
    return null;
  }
  const entityId = resolveEntityId(node);
  if (entityId === undefined || entityId === '') {
    return null;
  }
  return {
    descriptorKey: entry.key,
    entityId,
    model: workflowModel.getRenderableNodeModel(entry.key, entityId),
  };
}
